export function addContactForm(element) {

    if(!element) {
      return
    }

    const form = element.querySelector('form')
    const action = form.action

    const groups = Array.from(form.querySelectorAll('.form-group'))

    groups.forEach((el) => {
      const required = el.querySelector('span').innerHTML.includes('Required')
      if(required) {
        el.querySelector('input, textarea').required = true;
      }
    })

    form.addEventListener('submit', (e)=> {
      e.preventDefault()
      const formData = new FormData(form)
      post(formData)
    })

    const post = (formData) => {
      const postAddress = action
      const xhr = new XMLHttpRequest()

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          respond(xhr)
        }
      };

      xhr.open('POST', postAddress)
      xhr.send(formData)
    }

    const respond = (response) => {

      const resp = response.responseText

      if(resp.includes('alert-danger')) {
          let errorString = ''
          const tempDom = document.createElement('div')
          tempDom.innerHTML = resp

          const elems = Array.from(tempDom.querySelectorAll('.ccm-error li'))

          for (let i=0; i<elems.length; ++i) {
            errorString += elems[i].innerHTML + '\n'
          }

          console.log(errorString)

      } else  {
        window.location = window.base_path + '/thank-you'
      }
    }

}



// WEBPACK FOOTER //
// ./src/contact-form.js